<template>
    <div v-if="visible">
        <a-modal centered:bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <div class="custom-modal-header" v-if="data.title">
                <label class="custom-modal-header-title fs-20">
                    <span class="color-white">{{ data.title }}</span>
                </label>
            </div>
            <div class="custom-modal-body" v-if="data.message">
                <label class="custom-modal-body-detail fs-18">
                    {{ data.message }}
                </label>
            </div>
            <!-- footer -->
            <div class="custom-modal-footer text-center">
                <a-button size="large" class="text-center bg-red br-20" @click="confirm()" v-if="step == 'success'">
                    <span class="fs-18 color-white"> {{ $t('รับทราบ') }}</span>
                </a-button>
                <a-button size="large" class="text-center bg-red br-20" @click="cancel()" v-else-if="step == 'fail'">
                    <span class="fs-18 color-white"> {{ $t('ลองใหม่') }}</span>
                </a-button>
                <a-button size="large" class="text-center bg-red br-20" @click="cancel()" v-else>
                    <span class="fs-18 color-white"> {{ $t('ตกลง') }}</span>
                </a-button>
            </div>
        </a-modal>
    </div>
</template>
<script>
import { directive as onClickaway } from 'vue-clickaway';
export default {
    props: ['visible', 'step', 'data'],
    data() {
        return {};
    },
    methods: {
        cancel() {
            this.$emit('on-cancel');
        },
        confirm() {
            this.$emit('on-confirm');
        },
    },
    directives: {
        onClickaway: onClickaway,
    },
};
</script>
<style>
.modal {
    z-index: 100000 !important;
}
.modal .modal-content {
    margin: 0px !important;
}
</style>
<style scoped>
.center {
    margin: auto;
    width: 80%;
}
.green {
    color: green;
}
.dropbox {
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    /* background: lightcyan; */
    color: dimgray;
    padding: 10px 10px;
    min-height: 20vh; /* minimum height */
    position: relative;
    cursor: pointer;
}
.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 50vh;
    position: absolute;
    cursor: pointer;
}
.dropbox:hover {
    /* background: lightblue; */
}
.dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 14vh 0;
}
.remove-image {
    background: #cc0000;
    width: 48px;
    height: 48px;
    line-height: 42px;
    position: absolute;
    /* top: 3vh;
    right: 6.325vw; */
    right: 32px;
    z-index: 1;
}
/* @media screen and (max-width: 480px) {
    .remove-image {
        right: 25px;
    }
} */
.custom-modal-header {
    background: transparent;
    padding: 16px 10px;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-header-title {
    color: #141322 !important;
    font-weight: 600;
}
.custom-modal-body {
    background: transparent;
    padding: 16px 10px;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-body-detail {
    color: #141322 !important;
    font-weight: 300;
}
.custom-modal-footer {
    background: transparent;
    padding: 16px 10px;
}
</style>
